<template>
    <div class="pt-4">
        <div class="px-2 pt-2">
            <simular-proposta-tabela ref="simularTabela" :lotesItensSimularProposta="lotesItensSimularProposta" :licitacao="licitacao"></simular-proposta-tabela>
            <div class="az-actions-form">
                <div class="align-left"></div>
                <div class="align-right" style="display: flex">
                    <a class="action-primary btn-salvar" @click="gerarArquivo">Gerar Arquivo</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import SimularPropostaTabela from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/SimulaPropostaTabela'
import { mapState } from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
    name: 'LicitacaoVisualizacaoSimularProposta',
    components: { SimularPropostaTabela },
    data() {
        return {
            licitacaoId: null,
            lotesItensSimularProposta: [],
        }
    },
    async created() {
        await this.setLicitacaoId()
        await this.buscarListagemSimularProposta()
    },
    computed: {
        ...mapState(['licitacao'])
    },
    methods: {
        async buscarListagemSimularProposta() {
            const retorno = await this.$store.dispatch(actionTypes.BUSCAR_LISTAGEM_SIMULAR_PROPOSTA, this.licitacaoId)
            this.lotesItensSimularProposta = retorno
        },
        async gerarArquivo() {
            if (!this.$refs.simularTabela) {
                console.error('Referência ao componente SimularPropostaTabela não encontrada')
                return
            }

            const itens = this.$refs.simularTabela.lotesItensSimularProposta
            if (this.verificarValoresNaoPreenchidos(itens)) {
                return
            }

            const payload = {
                pregaoId: this.licitacaoId,
                items: itens.map(item => ({
                    licitacaoLoteItemId: item.licitacaoLoteItemId,
                    loteId: item.loteId,
                    marca: item.marca,
                    modelo: item.modelo,
                    valor: item.valorUnitario,
                    quantidade: item.quantidade
                }))
            }

            await this.$store.dispatch(actionTypes.GERAR_XML_PROPOSTA_PRESENCIAL, payload)
        },
        setLicitacaoId(){
            this.licitacaoId = Number(this.$route.params.id)
        },
        verificarValoresNaoPreenchidos(lista) {
            // Criar um mapa para armazenar os valores de valorUnitario por loteId
            const mapaLotes = new Map()

            for (const item of lista) {
                const { loteId, valorUnitario, loteDescricao } = item
                // Se o loteId já existir no mapa, adicionamos à lista existente, senão criamos uma nova lista
                if (!mapaLotes.has(loteId)) {
                    mapaLotes.set(loteId, [])
                }

                // Remover o ponto (milhar) e substituir a vírgula por ponto
                const valorConvertido = valorUnitario
                    ? parseFloat(String(valorUnitario).replace(/\./g, '').replace(',', '.')) // Remove ponto e troca vírgula por ponto
                    : NaN // Define como NaN se for inválido

                // Adiciona o novo item à lista do respectivo loteId
                mapaLotes.get(loteId).push({
                    valorUnitario: valorConvertido,
                    loteDescricao
                })
            }

            // Verificar se há algum loteId que atende à condição
            for (const itens of mapaLotes.values()) {
                let preenchido = false
                let vazio = false
                let loteDescricao = ''

                for (const item of itens) {
                    const valor = item.valorUnitario

                    if (!isNaN(valor) && valor > 0) {
                        preenchido = true
                    } else {
                        vazio = true
                    }

                    loteDescricao = item.loteDescricao
                }

                if (preenchido && vazio) {
                    alert(`Nem todos os itens do tipo ${loteDescricao} possuem um valor preenchido, favor verificar.`)
                    return true // Retorna true indicando que encontrou a situação
                }
            }

            return false // Retorna false caso não encontre
        }
    }
}
</script>